import { RolloverServiceClient } from "../../api-client-nswag/rollover-client";

import { useEffect, useState, useCallback } from "react";
import { REACT_APP_ROLLOVER_API_URL } from "../../envVariables";

let currentDate: Date | null = null;
export const dateStore = {
  set(date: Date | null) {
    currentDate = date;
  },
  get() {
    return currentDate;
  },
};

export const useRolloverDateResolver = (
  rolloverType: string,
  appName: string,
) => {
  const [disabledDates, setDisabledDates] = useState<Date[]>([]);
  const [resolvedDate, setResolvedDate] = useState<Date | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const rolloverServiceClient = new RolloverServiceClient(REACT_APP_ROLLOVER_API_URL);
  const resolveDate = useCallback(
    async (rolloverTypeDate: string, appName: string) => {
      if (rolloverTypeDate === "0") return;

      setLoading(true);
      const rejectedDates: Date[] = [];
      let currentDate = new Date();
      const capacityByDate =
        await rolloverServiceClient.taxPortal_GetAllRolloverCapacity(
          rolloverTypeDate,
          appName,
        );
      for (const capacity of capacityByDate) {
        if (!capacity.rejectedDate) {
          const normalized = capacity.rolloverDate
            ? new Date(capacity.rolloverDate)
            : new Date(currentDate);
          normalized.setHours(0, 0, 0, 0);
          setResolvedDate(normalized);
          currentDate = new Date(
            currentDate.setDate(currentDate.getDate() + 1),
          );
        }
        if (capacity.rejectedDate) {
          const normalized = capacity.rolloverDate
            ? new Date(capacity.rolloverDate)
            : new Date(currentDate);
          normalized.setHours(0, 0, 0, 0);
          rejectedDates.push(normalized);
          currentDate = new Date(
            currentDate.setDate(currentDate.getDate() + 1),
          );
        }
      }
      setDisabledDates(rejectedDates);
      setLoading(false);
    },
    [],
  );
  useEffect(() => {
    resolveDate(rolloverType, appName);
  }, [resolveDate, rolloverType, appName]);

  return {
    disabledDates,
    resolvedDate,
    loading,
  };
};
